export const EXCLUDE_BOOTSTRAP_ROUTES = [
	"/",
	"/jobs",
	"/companies",
	"/companies/:id",
	"/companies/:id/embed",
	"/companies/:id/claim",
	"/company/dashboard",
	"/company/dashboard/:tab",
	"/company/setup",
	"/company/upgrade",
	"/jobs/:id",
	"/profile",
	"/payments",
	"/rewards",
	"/forgot-password",
	"/fitcheckme",
	"/fitchecks",
	"/applications",
	"/register",
	"/register/create-account",
	"/signin",
	"/creating-profile",
	"/for-employers",
	"/claim-mini-landing",
	"/about-us",
	"/help-&-support",
	"resume-tips",
	"/articles",
	"/app-auth",
	"/articles/:id",
	"/articles/:id/:slug",
	"/control-center/opportunities",
	"/control-center/opportunity-details",
	"/onboarding",
	// Resume builder (the 21 routes nested under ResumerBuilderLayout).
	// Exact paths only - /resume/review still keeps Bootstrap because it renders the
	// live .resume-scope template preview. /view-pdf no longer does: it was rebuilt in
	// Tailwind/shadcn (only an <iframe> PDF + app chrome), so it opts out of the legacy layer.
	"/view-pdf",
	"/resume/select-template",
	"/resume/create-resume-options",
	"/resume/select-experience",
	"/resume/contact-information",
	"/resume/work-history",
	"/resume/work-history-summary",
	"/resume/education-information",
	"/resume/education-summary",
	"/resume/skills",
	"/resume/brief-summary",
	"/resume/extras",
	"/resume/accomplishments",
	"/resume/affiliations",
	"/resume/personal-links",
	"/resume/certifications",
	"/resume/additional-information",
	"/resume/languages",
	"/resume/personal-profile",
	"/resume/reference-information",
	"/resume/reference-summary",
	"/resume/custom-extra/:customExtra",
];
